"use strict";

exports.__esModule = true;
exports.removeNode = removeNode;

function removeNode(el) {
  var parent = el.parentNode;

  if (parent) {
    parent.removeChild(el);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/utils/dom/node.js
// module id = 321
// module chunks = 1 2 3 4 5